import React from 'react';
import { Link } from 'react-router-dom';
import './ISO13485.css';

const ISO13485 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 13485 Quality Management System for Medical Devices</h1>
            <h2 className="page-subtitle">ISO 13485: The Key to Excellence in Medical Devices</h2>
            <div className="page-text-content">
              <p>
                NQC (Nova Quality Certification Agency) is a leading organization known for its 
                professional certification and accreditation services. One of these services, 'ISO 13485 
                Quality Management System for Medical Devices,' is a standard of critical importance for 
                companies operating in the healthcare sector. In this article, we will focus on the 
                details of ISO 13485, aiming to understand the advantages it offers and how crucial it 
                is for organizations.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 13485?</h2>
            <div className="page-text-content">
              <p>
                ISO 13485 is a quality management system for organizations manufacturing medical devices 
                or providing healthcare services. This standard emphasizes product safety, quality, and 
                regulatory compliance, ensuring that medical devices meet the highest standards of 
                safety and effectiveness.
              </p>
              <p>
                ISO 13485 standards provide a framework for the medical device industry, covering legal 
                regulations, product safety, continuous improvement, and quality management, aiming for 
                worldwide acceptance and international trade. The standard helps organizations establish, 
                implement, and maintain effective quality management systems specifically designed for 
                medical devices.
              </p>
              <p>
                Risk management principles are a key element of ISO 13485, enabling organizations to 
                identify, assess, and control risks throughout the product lifecycle. The standard 
                requires organizations to maintain compliance through regular audits and certification, 
                ensuring ongoing adherence to quality and safety requirements.
              </p>
              <p>
                Implementing ISO 13485 offers numerous advantages, including customer confidence, 
                regulatory compliance, competitive advantage in global markets, enhanced product quality 
                and safety, and opportunities for continuous improvement. The standard helps organizations 
                demonstrate their commitment to producing safe and effective medical devices.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Key Elements of ISO 13485:</h2>
            <div className="elements-list">
              <div className="element-item">
                <h3 className="element-title">1. Legal and Regulatory Compliance</h3>
                <p className="element-description">
                  ISO 13485 aims for full compliance with legal and regulatory requirements for medical 
                  device manufacturers, facilitating the global market release of products.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">2. Risk Management</h3>
                <p className="element-description">
                  The standard requires organizations to adopt risk management principles to enhance 
                  product safety throughout the product lifecycle.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">3. Product Safety</h3>
                <p className="element-description">
                  ISO 13485 focuses on product safety from design to production and use, ensuring 
                  medical devices are used safely and effectively.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">4. Quality Management System (QMS)</h3>
                <p className="element-description">
                  ISO 13485 requires organizations to establish and maintain a quality management 
                  system, promoting continuous improvement.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">5. Product Development and Validation</h3>
                <p className="element-description">
                  The standard regulates the development processes of medical devices, ensuring products 
                  function as intended and meet user requirements.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Advantages of ISO 13485 Certification:</h2>
            <div className="advantages-list">
              <div className="advantage-item">
                <h3 className="advantage-title">Competitive Advantage in the Global Market</h3>
                <p className="advantage-description">
                  ISO 13485 certification provides medical device manufacturers with a competitive 
                  advantage in the global market as many countries require this certification.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">Customer Confidence</h3>
                <p className="advantage-description">
                  ISO 13485 assures customers that medical devices are manufactured according to specific 
                  quality and safety standards, increasing customer satisfaction.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">Regulatory Compliance</h3>
                <p className="advantage-description">
                  ISO 13485 guides organizations in complying with regulatory requirements, making it 
                  easier to fulfill legal obligations.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">Product Quality and Safety</h3>
                <p className="advantage-description">
                  The standard offers an effective framework to enhance product quality and safety, 
                  helping organizations reduce product errors.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">Continuous Improvement</h3>
                <p className="advantage-description">
                  ISO 13485 provides organizations with opportunities for continuous improvement, making 
                  processes more effective.
                </p>
              </div>
            </div>
            <div className="page-text-content">
              <p>
                ISO 13485 Quality Management System for Medical Devices is one of the expertise areas of 
                NQC (Nova Quality Certification Agency). Our company ensures the compliance of 
                organizations operating in the healthcare industry with quality standards by offering 
                expertise in this important standard.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO13485;

